import { ChangeDetectorRef, DestroyRef, inject } from '@angular/core';

export abstract class BaseAdsExpensesComponent {
  protected _destroyRef = inject(DestroyRef);
  protected _cdRef = inject(ChangeDetectorRef);
}
